function selectSizeBtnClicked(btn) {
  Array.from(btn.parentElement.children).forEach((childBtn) =>
    childBtn.classList.remove("selected")
  );
  btn.classList.add("selected");
  const buyBtn = btn.closest(".styles-product").querySelector(".rtw-buy-button");
  buyBtn.classList.remove("disabled");
  buyBtn.dataset.id = btn.dataset.id;
}

function buyBtnClicked(buyBtn) {
  //If a size was selected
  if (buyBtn.dataset.id)
    window.open(`https://royer.com/products/${buyBtn.dataset.ref}?variant=${buyBtn.dataset.id}`);
  else window.open(`https://royer.com/products/${buyBtn.dataset.ref}`);
}